export enum ERoleSystem {
  ADMIN = 'admin', // Администратор
  ADMIN_VIEW = 'admin_view', // Администратор (только просмотр)
  USER = 'user', // Пользователь
}
